// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__2ZzrF","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__3onoA","gfeWrapper":"CalendarEvent_gfeWrapper__2MpE4"};